import {makeAutoObservable} from 'mobx'

export default class MonthCalcSetting {
  id: number

  month: number

  numericYear: number

  hebrewMonthName?: string

  textYear?: string

  paymentPercent: number

  paymentCapDollar: number

  dollarRate: number

  isLocked: boolean

  constructor(data: any) {
    this.id = data.Id ?? data.id ?? 0
    this.month = data.Month ?? data.month
    this.numericYear = data.NumericYear ?? data.numericYear
    this.hebrewMonthName = data.HebrewMonthName ?? data.hebrewMonthName
    this.textYear = data.TextYear ?? data.textYear
    this.paymentPercent = data.PaymentPercent ?? data.paymentPercent ?? 15
    this.paymentCapDollar = data.PaymentCapDollar ?? data.paymentCapDollar ?? 85
    this.dollarRate = data.DollarRate ?? data.dollarRate ?? 3.8
    this.isLocked = data.IsLocked ?? data.isLocked ?? false
    makeAutoObservable(this)
  }
}
